function setMercaCookie(name, value, minutes) {
  const date = new Date();
  date.setTime(date.getTime() + minutes * 60 * 1000); // Set expiry date
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/; Secure;`;
}

function getMercaCookieValue(allCookies, cookieName) {
  for (let cookie of allCookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(`${cookieName}=`) === 0) {
      return cookie.substring(cookieName.length + 1);
    }
  }
  return null;
}

function fetchData() {
  const browserCookie = document.cookie ? document.cookie.split(';') : [];

  const requestData = {
    viewport_width: window.innerWidth ? `${window.innerWidth}` : null,
    viewport_height: window.innerHeight ? `${window.innerHeight}` : null,
    device_pixel_ratio: window.devicePixelRatio
      ? `${window.devicePixelRatio}`
      : null,
    device_memory: navigator.deviceMemory ? `${navigator.deviceMemory}` : null,
    device_language: navigator.language ? `${navigator.language}` : null,
    location: location.href ? `${location.href}` : null,
    brand: 'KAMIKUBI',
    _fbp: getMercaCookieValue(browserCookie, '_fbp') || null,
    _ga: getMercaCookieValue(browserCookie, '_ga') || null,
    _gid: getMercaCookieValue(browserCookie, '_gid') || null,
    _gcl_au: getMercaCookieValue(browserCookie, '_gcl_au') || null,
    _shopify_y: getMercaCookieValue(browserCookie, '_shopify_y') || null,
    _shopify_s: getMercaCookieValue(browserCookie, '_shopify_s') || null,
    ma_id: getMercaCookieValue(browserCookie, 'ma_id') || null,
    ma_s: getMercaCookieValue(browserCookie, 'ma_s') || null,
  };
  fetch('https://pixel.merca.ai/v1/pixel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestData),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && !data.isPixelPresent) {
        setMercaCookie('ma_id', data.pixelId, 90 * 24 * 60);
      }
      if (data && !data.isSessionPresent) {
        setMercaCookie('ma_s', data.sessionId, 30);
      }
    })
    .catch((err) => console.log(err));

  // // fetch('https://pixel.merca.ai/v1/pixel', {
  // fetch('https://b808c1f22d1d.ngrok-free.app/v1/device-bucket', {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
  //   body: JSON.stringify({ brand: 'DOODLAGE' }),
  // })
  //   .then((response) => response.json())
  //   .then((data) => console.log(data))
  //   .catch((err) => console.log(err));
}

function checkAndFetch() {
  const checkInterval = 100;
  const timeoutDuration = 60000;
  let elapsedTime = 0;

  function findGid() {
    const gid = document.cookie.match(/_ga=([^;]+)/);
    if (gid) {
      clearInterval(checkIntervalId);
      fetchData();
    } else if (elapsedTime < timeoutDuration) {
      elapsedTime += checkInterval;
    } else {
      clearInterval(checkIntervalId);
      fetchData();
    }
  }

  const checkIntervalId = setInterval(findGid, checkInterval);
}

checkAndFetch();
